import React, { Component, Fragment } from 'react';
import styled from 'styled-components';
import { media, screenSizes } from '../helpers/styleConstants';
import { wlPath, wlVar } from '../helpers/whitelabel';
import { Elevation, Icon, Theme, Typography } from 'rmwc';
import { humanPhoneNumber } from '../helpers/stringHelper';

const StyledContactInfoContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const ContactDetails = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  ${media.phoneOnly`
    flex-direction: row;
    align-items: flex-end;
    justify-content: center;
  `};
`;

const CircularButton = styled.div`
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

const PhoneButton = CircularButton.extend`
  background: #66dc16;
  width: 45px;
  height: 45px;
`;

const EmailButton = CircularButton.extend`
  background: #4a90e2;
  width: 45px;
  height: 45px;
`;

export class ContactFooterContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasMobileWidth:
        Math.max(document.documentElement.clientWidth, window.innerWidth || 0) < screenSizes.tabletPortraitUp,
    };
  }

  componentDidMount() {
    this.updateWidth();
    window.addEventListener('resize', this.updateWidth);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWidth);
  }

  updateWidth = () => {
    this.setState({
      hasMobileWidth:
        Math.max(document.documentElement.clientWidth, window.innerWidth || 0) < screenSizes.tabletLandscapeUp,
    });
  };

  render() {
    const { hasMobileWidth } = this.state;

    return (
      <Fragment>
        <div className="contact-footer" style={{ background: 'rgba(255, 255, 255, 0.95)' }}>
          <StyledContactInfoContainer>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <img src={wlVar('headshot_url')} />
              <div style={{ marginLeft: 6, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                {hasMobileWidth ? (
                  <Fragment>
                    <Typography tag="div" use="body1" style={{ letterSpacing: 0, lineHeight: 1 }} className="mb-1">
                      <strong>{wlVar('advisor_name')}</strong>
                    </Typography>
                    <Typography tag="div" use="body2" style={{ marginTop: -4, letterSpacing: 0, lineHeight: 1 }}>
                      {wlVar('brand_name')}
                    </Typography>
                  </Fragment>
                ) : (
                  <Fragment>
                    <Typography tag="div" use="headline6">
                      {wlVar('advisor_name')}
                    </Typography>
                    <Typography tag="div" use="subtitle1" style={{ marginTop: -4 }}>
                      {wlVar('brand_name')}
                    </Typography>
                  </Fragment>
                )}
              </div>
            </div>

            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <a href={`mailto:${wlVar('display_email')}`}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <EmailButton>
                    <Icon>email</Icon>
                  </EmailButton>
                  {hasMobileWidth || (
                    <Typography tag="div" use="subtitle1" className="ml-2 mr-2" style={{ color: '#4a90e2' }}>
                      {wlVar('display_email')}
                    </Typography>
                  )}
                </div>
              </a>
              <a href={`tel:${wlVar('phone_number')}`} rel="nofollow">
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <PhoneButton className="ml-4">
                    <Icon>phone</Icon>
                  </PhoneButton>
                  {hasMobileWidth || (
                    <Typography tag="div" use="subtitle1" className="ml-2 mr-2" style={{ color: '#66dc16' }}>
                      {humanPhoneNumber(wlVar('phone_number'))}
                    </Typography>
                  )}
                </div>
              </a>
            </div>
          </StyledContactInfoContainer>
        </div>
      </Fragment>
    );
  }
}

const StyledFooterContainer = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
  bottom: 5px;
  z-index: 50;
`;

const StyledElevation = styled(Elevation)`
  max-width: 780px;
  width: 80%;
  margin: auto;

  ${media.phoneOnly`
    width: 95%;
  `};
`;

export const ContactFooterFloat = () => (
  <StyledFooterContainer>
    <StyledElevation z={2}>
      <ContactFooterContent />
    </StyledElevation>
  </StyledFooterContainer>
);

export const ContactFooterShim = styled.div`
  height: 96px;
  margin-top: 1rem;
`;
